import { render, staticRenderFns } from "./home_acco.vue?vue&type=template&id=4081a6c7&"
import script from "./home_acco.vue?vue&type=script&lang=js&"
export * from "./home_acco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports